import { h } from 'vue';
import FormField from './FormField';

/**
 * Wraps the supplied form control component in a FormField.
 * @param {Object} Component Vue component options.
 * @returns A higher-order component consisting of the supplied
 *  component options wrapped in a FormField.
 */
export default function makeFormField(Component) {
  return {
    render() {
      return h(
        FormField,
        null,
        {
          default: ({ attrs, classes }) => h(
            Component,
            {
              ...attrs,
              class: classes
            }
          )
        },
      );
    }
  };
}
